<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:20px;display:flex">
          <span class="countryName">分类</span>
          <!-- <el-cascader placeholder="请输入国家名称"></el-cascader> -->
          <el-input placeholder="输入关键字" v-model="countryName" clearable></el-input>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
            <el-button type="primary">导出</el-button>
          </el-row>
        </div>
      </div>
      <el-button type="success" style="margin:10px 0" @click="addResponseLibraryData()">新增条目</el-button>
      <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="level1_cate_name" label="一级分类"></el-table-column>
        <el-table-column prop="level2_cate_name" label="二级分类"></el-table-column>
        <el-table-column prop="level3_cate_name" label="三级分类"></el-table-column>
        <el-table-column prop="update_time" label="创建时间" sortable></el-table-column>
        <el-table-column prop="update_time" label="最后修改时间" sortable></el-table-column>
        <el-table-column prop="last_admin_username" label="操作人">
          <template slot-scope="scope">
            <span>{{scope.row.last_admin_username || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addResponseLibraryData(scope.row)">
              <i class="el-icon-edit"></i>编辑
            </el-button>
            <el-button type="text" size="small" @click="deleteData(scope.row)">
              <i class="el-icon-delete"></i>删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "./api";

export default {
  name: "ResponseLibrary",
  data() {
    return {
      addressSelectData: null,
      addressItem: null,
      countryName: "",
      tableData: [],
      currentPage: 1,
      totalList: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData(data) {
      api
        .responseList(data)
        .then(res => {
          // this.$message("请求成功!");
          this.tableData = res.list;
          this.totalList = res.recordcount;
          this.pageSize = res.pagecount;
          // console.log(res);
        })
        .catch(err => {
          // console.log(err);
        });
    },

    // 查询参数
    queryData() {
      debugger;
      let data = {
        q: this.countryName
      };
      if (data.q) {
        this.getData(data);
      } else {
        this.getData();
      }
    },

    // 新增数据
    addResponseLibraryData(row) {
      let routeData = this.$router.resolve({
        name: "addResponseLibraryData",
        query: {
          editId: row ? row.id : false,
          name: row ? row.level1_cate_name : null
        }
      });
      window.open(routeData.href, '_blank');
    },

    // 删除数据
    deleteData(row) {
      debugger;
      let data = {
        id: row.id
      };
      this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(data);
        })
        .catch(() => {});
    },

    delete(data) {
      api
        .recordedDelete(data)
        .then(res => {
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.getData();
        })
        .catch(err => {});
    },

    //改变每页显示数量重新请求数据，重置当前页为第一页
    handleSizeChange(val) {
      let pageSize = { pagesize: val };
      this.getData(pageSize);
    },

    //点击改变当前页
    handleCurrentChange(val) {
      let page = { page: val };
      this.getData(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>